import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';

/** The Markdown syntax tree WorkspaceMarkdown renders (mdast, with positions). */
export type MarkdownNode = {
  type: string;
  value?: string;
  url?: string;
  depth?: number;
  ordered?: boolean;
  align?: (string | null)[];
  children?: MarkdownNode[];
  position?: { start: { offset?: number }; end: { offset?: number } };
};

/** Parse company Markdown exactly as the workspace renders it (GFM). */
export const parseMarkdownTree = (text: string) =>
  unified().use(remarkParse).use(remarkGfm).parse(text) as MarkdownNode;
